/* TÉR ÖNMAGADHOZ – interakciók (Shopify OS 2.0)
 *
 * Eltérés a statikus REV4 main.js-hez képest:
 * a theme editorban a Shopify újrarendereli az épp szerkesztett sectiont,
 * ezért minden inicializálást egy gyökér-elemre szűkítünk (initAll(root)),
 * és a `shopify:section:load` eseményre újrafuttatjuk. Enélkül a szerkesztő
 * előnézetében a fülek / accordionok / belépő animáció holtan maradnának.
 * A boltban (nem szerkesztőben) a viselkedés 1:1 azonos a REV4-gyel.
 */
(function () {
  "use strict";

  /* 1. Mobil navigáció – nyit/zár, X ikon (CSS), Esc, háttér-görgetés zárolása */
  function initNav(root) {
    var nav = root.querySelector("[data-nav]");
    var toggle = root.querySelector("[data-nav-toggle]");
    if (!nav || !toggle) return;

    var labelOpen = toggle.getAttribute("data-label-open") || "Menü";
    var labelClose = toggle.getAttribute("data-label-close") || "Menü bezárása";

    function setOpen(open) {
      nav.setAttribute("data-open", String(open));
      toggle.setAttribute("aria-expanded", String(open));
      toggle.setAttribute("aria-label", open ? labelClose : labelOpen);
      // a fixed menüpanel alatt ne görögjön a háttér
      document.body.style.overflow = open ? "hidden" : "";
    }

    toggle.addEventListener("click", function () {
      setOpen(nav.getAttribute("data-open") !== "true");
    });

    // link kattintásra zárás mobilon
    nav.querySelectorAll(".nav__menu a").forEach(function (a) {
      a.addEventListener("click", function () { setOpen(false); });
    });

    // háttérre koppintás zár: a teljes képernyős panelen a linkeken KÍVÜLI terület
    // is bezáró felület (Barni kikötése). Csak magára a panelre és a listaelemekre
    // reagálunk, hogy egy link-koppintás ne záródjon le kétszer.
    var menu = nav.querySelector(".nav__menu");
    if (menu) {
      menu.addEventListener("click", function (e) {
        if (e.target === menu || e.target.tagName === "LI") { setOpen(false); }
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && nav.getAttribute("data-open") === "true") {
        setOpen(false);
        toggle.focus();
      }
    });

    setOpen(false);
  }

  /* 2. Accordion (kineziológia, GYIK) – akadálymentes, animált magasság */
  function initAccordions(root) {
    root.querySelectorAll("[data-accordion]").forEach(function (acc) {
      acc.querySelectorAll(".acc__head").forEach(function (head) {
        var panel = head.nextElementSibling;
        head.addEventListener("click", function () {
          var expanded = head.getAttribute("aria-expanded") === "true";
          head.setAttribute("aria-expanded", String(!expanded));
          if (expanded) {
            panel.style.height = panel.scrollHeight + "px";
            requestAnimationFrame(function () { panel.style.height = "0px"; });
          } else {
            panel.style.height = panel.scrollHeight + "px";
            panel.addEventListener("transitionend", function te() {
              panel.style.height = "auto";
              panel.removeEventListener("transitionend", te);
            });
          }
        });
      });
    });
  }

  /* 3. Finom belépő animáció */
  function initReveal(root) {
    if (!("IntersectionObserver" in window)) {
      root.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-visible"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    root.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
    /* Biztonsági háló: a nagy, viewportnál magasabb above-the-fold blokkok (pl. hero)
       0.12 threshold mellett nem mindig "intersecting"-elnek betöltéskor -> azonnal
       felfedjük azt, ami már a képernyőn van; a scroll-animáció a többinek megmarad. */
    requestAnimationFrame(function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      root.querySelectorAll(".reveal:not(.is-visible)").forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) { el.classList.add("is-visible"); io.unobserve(el); }
      });
    });
  }

  /* 4. Aktuális év a láblécben */
  function initYear(root) {
    var y = root.querySelector("[data-year]");
    if (y) y.textContent = new Date().getFullYear();
  }

  /* 5. Fülek (tabs) – akadálymentes: kattintás + nyíl/Home/End billentyűk */
  function initTabs(root) {
    root.querySelectorAll("[data-tabs]").forEach(function (group) {
      var tabs = Array.prototype.slice.call(group.querySelectorAll('[role="tab"]'));
      var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute("aria-controls")); });
      function select(i) {
        tabs.forEach(function (t, j) {
          var sel = j === i;
          t.setAttribute("aria-selected", String(sel));
          t.tabIndex = sel ? 0 : -1;
          if (panels[j]) panels[j].hidden = !sel;
        });
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener("click", function () { select(i); });
        tab.addEventListener("keydown", function (e) {
          var idx = i;
          if (e.key === "ArrowRight" || e.key === "ArrowDown") idx = (i + 1) % tabs.length;
          else if (e.key === "ArrowLeft" || e.key === "ArrowUp") idx = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === "Home") idx = 0;
          else if (e.key === "End") idx = tabs.length - 1;
          else return;
          e.preventDefault(); select(idx); tabs[idx].focus();
        });
      });
    });
  }

  /* 6. Kártya-carousel 3D (csak mobilon) – a KÖZÉPSŐ kártya teljes méretű és
   *    egyenesen áll, a szomszédok kisebbek, halványabbak és enyhén elfordulnak.
   *    A hatás FOLYAMATOS: a scroll-pozícióból számoljuk, tehát a kártya húzás
   *    közben „fordul be”, nem egy ugró állapotváltás.
   *    A center-snap maga tiszta CSS – ez a réteg csak a látvány, JS nélkül is
   *    működik a carousel.
   */
  function initCarousel3D(root) {
    var mqMobile = window.matchMedia("(max-width: 620px)");
    var mqMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    var tracks = root.querySelectorAll(".grid-services, .grid-cards, .grid-2, .post-grid, .fiore-grid");

    tracks.forEach(function (track) {
      var cards = Array.prototype.slice.call(track.children);

      function reset() {
        cards.forEach(function (c) { c.style.transform = ""; c.style.opacity = ""; });
      }

      function update() {
        if (!mqMobile.matches || mqMotion.matches) { reset(); return; }
        var r = track.getBoundingClientRect();
        var center = r.left + r.width / 2;
        cards.forEach(function (card) {
          var b = card.getBoundingClientRect();
          // -1 = teljesen balra, 0 = pontosan középen, 1 = teljesen jobbra
          var d = (b.left + b.width / 2 - center) / (r.width / 2);
          d = Math.max(-1, Math.min(1, d));
          var a = Math.abs(d);
          // max 7 fok: nagyobb szögnél gyenge GPU-jú telefonon elmosódna a szöveg
          card.style.transform = "scale(" + (1 - 0.08 * a).toFixed(3) + ") rotateY(" + (-7 * d).toFixed(2) + "deg)";
          card.style.opacity = (1 - 0.25 * a).toFixed(3);
        });
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }

      track.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", update);
      // ha a látogató menet közben kapcsol csökkentett mozgásra, azonnal álljunk le
      if (mqMotion.addEventListener) mqMotion.addEventListener("change", update);
      update();
    });
  }

  /* 7. Önismereti kísérés – útválasztó. A látogató a saját helyzetére koppint,
   *    és a hozzá tartozó út jelenik meg. Kattintás/érintés + nyíl/Home/End.
   *
   *    FONTOS: a rejtést EZ a függvény engedélyezi (`is-armed` osztály). Ha a JS
   *    nem fut, a CSS minden panelt a normál folyamban hagy -> a látogató mindent
   *    lát. Soha nem fordul elő üres doboz. (Ugyanez a minta védi a hero pilléreit.)
   */
  function initGuidance(root) {
    root.querySelectorAll("[data-guidance]").forEach(function (guide) {
      var tabs = Array.prototype.slice.call(guide.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(guide.querySelectorAll('[role="tabpanel"]'));
      if (!tabs.length || tabs.length !== panels.length) return;

      guide.classList.add("is-armed");

      function select(i) {
        tabs.forEach(function (t, j) {
          var sel = j === i;
          t.setAttribute("aria-selected", String(sel));
          t.tabIndex = sel ? 0 : -1;
          panels[j].setAttribute("data-active", String(sel));
        });
      }

      /* HOVER-FELTÁRULÁS (Barni, 2026-07-14): egérrel ráhúzásra fed fel, nem kell kattintani.
         A `select()` nem áll vissza magától -> „ami felfedve, felfedve marad": az utoljára
         felfedett út marad a panelen, amíg mást nem választ. Újratöltéskor az első jön (select(0)).
         Kattintás / érintés / billentyű változatlanul működik — érintőképernyőn nincs hover,
         ott a kattintás fed fel. Az `mouseenter` nem buborékol, ezért gomb-szinten kötjük. */
      /* KÉSLELTETETT HOVER (130 ms): csak akkor vált, ha a kurzor OTT IS MARAD. Enélkül a
         soron való gyors áthúzás négyszer átvillantaná a panelt — pont az ellenkezője a
         lassú, meditatív feltárulásnak. Kattintás és érintés AZONNALI marad. */
      var hoverTimer = null;
      guide.addEventListener("mouseleave", function () { clearTimeout(hoverTimer); });

      tabs.forEach(function (tab, i) {
        tab.addEventListener("mouseenter", function () {
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(function () { select(i); }, 130);
        });
        tab.addEventListener("mouseleave", function () { clearTimeout(hoverTimer); });
        tab.addEventListener("click", function () { clearTimeout(hoverTimer); select(i); });
        tab.addEventListener("keydown", function (e) {
          var idx = i;
          if (e.key === "ArrowRight" || e.key === "ArrowDown") idx = (i + 1) % tabs.length;
          else if (e.key === "ArrowLeft" || e.key === "ArrowUp") idx = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === "Home") idx = 0;
          else if (e.key === "End") idx = tabs.length - 1;
          else return;
          e.preventDefault(); select(idx); tabs[idx].focus();
        });
      });

      select(0);
    });
  }

  /* 8. Űrlap-visszajelzés: küldés után a lap NEM oda ugrik, ahol a visszajelzés van
   *    (a Shopify a lap tetejére tölt vissza). Odavisszük a fókuszt és a nézetet,
   *    hogy a látogató LÁSSA, elment-e az üzenet vagy hibázott.
   */
  function initFormNote(root) {
    var note = root.querySelector("[data-form-note]");
    if (!note) return;
    note.scrollIntoView({ block: "center", behavior: "auto" });
    note.focus({ preventScroll: true });
  }


  /* 6b. Szám-számláló (stat-band 2700+) – felfut, amikor a sávba görgetünk.
   *     GARANCIÁK: a végső érték a DOM-ban van (data-count-to a fallback szám maga a
   *     szöveg), tehát IntersectionObserver / JS / csökkentett mozgás nélkül is a kész
   *     szám látszik – az animáció csak rátesz, nem ő engedélyezi a láthatóságot. */
  function initCounters(root) {
    var els = root.querySelectorAll("[data-count-to]");
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !("IntersectionObserver" in window)) return; // marad a statikus végérték

    function run(el) {
      var target = parseInt(el.getAttribute("data-count-to"), 10);
      if (isNaN(target)) return;
      var dur = 1400, start = null;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
        el.textContent = String(Math.round(target * eased)); // sima számjegyek: „2700" marad, nem „2 700"
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = String(target);
      }
      requestAnimationFrame(step);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initAll(root) {
    initNav(root);
    initAccordions(root);
    initReveal(root);
    initYear(root);
    initTabs(root);
    initCarousel3D(root);
    initGuidance(root);
    initFormNote(root);
    initCounters(root);
  }

  initAll(document);

  /* Theme editor: az újrarenderelt section belsejét újra be kell kötni. */
  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });

  /* 7. CSAK a theme editorban: a pillér-sáv mobilon rotál (tiszta CSS), ezért a
   *    szerkesztett pillér épp láthatatlan is lehet. Ha Barni kiválaszt egy blokkot,
   *    megállítjuk a rotációt és azt az egyet mutatjuk. A boltban ez a kód nem fut
   *    (Shopify.designMode csak a szerkesztőben igaz), tehát a látogatónál a
   *    láthatóságot továbbra sem a JS engedélyezi.
   */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:block:select", function (e) {
      var pillar = e.target.closest ? e.target.closest(".pillar") : null;
      if (!pillar) return;
      var bar = pillar.parentElement;
      bar.classList.add("is-editing");
      bar.querySelectorAll(".pillar").forEach(function (p) { p.classList.remove("is-selected"); });
      pillar.classList.add("is-selected");
    });

    document.addEventListener("shopify:block:deselect", function (e) {
      var pillar = e.target.closest ? e.target.closest(".pillar") : null;
      if (!pillar) return;
      pillar.classList.remove("is-selected");
      pillar.parentElement.classList.remove("is-editing");
    });
  }
})();
